import React,{ useState, useEffect } from 'react'
import { useCart } from './CartContext';
import './CartDrawer.css';
import { useNavigate  } from "react-router-dom";
import { useAuth } from '../firebase/AuthContext';

function CartDrawer({ isOpen, onClose }) {
  const { cartItems, removeFromCart, incrementQuantity, decrementQuantity } = useCart();
  const { user, handleUserNavigation } = useAuth();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();

  const calculateFullTotalPrice = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2);
  };
 
  const handleCheckoutClick = () => {
    if (user) {  // Use the user object to check authentication
      if (cartItems.length === 0) {
        alert("Please add products to the cart before proceeding to checkout.");
      } else {
        navigate('/checkout');  // Utilize the existing navigation handler
      }
    } 
    else if(!user){
      if (cartItems.length === 0) {
      alert("Please add products to the cart before proceeding to checkout.");
      }
      else{
        // alert("Please log in first to proceed with checkout.");
        // handleUserNavigation();  // This will navigate to login if not logged in
        navigate('/checkout');
      }
    }
  };

  const handleCartClick = () => {
    navigate('/cart'); // Navigate to the product detail page with the specific product ID
  };

  const handleProductClick = (Id) => {
    navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
  };

  return (
    <>
    {/* Overlay */}
    {isOpen && <div className="cart-drawer-overlay" onClick={onClose}></div>}
    
    <div className={`cart-drawer ${isOpen ? 'open' : ''}`}>
      <div className="cart-drawer-header">
        <h3>Shopping Cart</h3>
        <button onClick={onClose} className="close-drawer-btn">
          &times;
        </button>
      </div>

      {/* Scrollable Cart Items List */}
  <div className="cart-drawer-list-container">
      <ul className="cart-drawer-list">
        {cartItems.map((item) => (
          <li key={item.id} className="cart-drawer-item">
            <img src={item.imageUrl[0]} alt={item.title} onClick={() => handleProductClick(item.id)} className="cart-drawer-item-image" />
            <div className="cart-drawer-item-info">
              <h4 className='cart-drawer-item-title'>{item.title}</h4>
              <p>Rs. {(item.price * item.quantity).toFixed(2)}</p>
              <div className='drawer-cart-btn-container'
               onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the product click event
                }} >
                <button
                  onClick={() => decrementQuantity(item)}
                  className="drawer-cart-decrement-btn"
                >
                  -
                </button>
                <div className="drawer-cart-quantity">{item.quantity}</div>
                {/* <span className="drawer-cart-quantity">{item.quantity}</span> */}
                <button
                  onClick={() => incrementQuantity(item)}
                  className="drawer-cart-increment-btn"
                >
                  +
                </button>
                <button onClick={() => removeFromCart(item)} className='remove-btn'>Remove</button>
              </div>
            </div>
          </li>
        ))}
      </ul>
      </div>
   
    {/* <div className='order-summary-container'> */}
      <div className='drawer-order-summary'>
        <h2 className='drawer-order-summary-header'>Order summary</h2>
        <div>
          <div className='drawer-sub-total'>
            <span> Subtotal </span>
            <span> Rs.{calculateFullTotalPrice()} </span>
          </div>
          <p className='drawer-calculate-taxes'>
            Taxes and shipping calculated at checkout
          </p>
        </div>
        <button onClick={handleCheckoutClick} className='drawer-check-out-button'>
          <i class="ri-lock-2-line"></i>
          Proceeding checkout 
        </button>
      </div>
    {/* </div> */}

    <div className='drawer-view-cart-container'>
    <span onClick={handleCartClick} className='drawer-view-cart'>
      View Cart
    </span>
    </div>
      
    </div>
    </>
  );
}

export default CartDrawer;